<template>
    <!--我的班主任-->
  <div id="headteacher">
    <h2 class="title">
      <a href="" class="prev"></a>
      您有一节1680元精品课，快预约吧
    </h2>
    <div class="main">
      <dl class="yuyue">
        <dt></dt>
        <dd>
          <h3>预约成功</h3>
          <p>
            课程：教师资格笔试全程班 稍后会有学习规划师与你联系，请保持手机畅通！
          </p>
        </dd>
      </dl>
      <dl class="step2">
        <dt>2</dt>
        <dd>
          <h3>加班主任微信，获得一对一服务</h3>
          <p>
            陪伴学习，内部资料，爆款好课都给你
          </p>
          <div class="profile">
            <div class="left">
              <img src="../../assets/img/personnote_img_avatar1.png" alt="">
            </div>
            <div class="right">
              <p>
                班主任：冯老师 <br>
                微信号：12345678990
              </p>
              <a href="">复制微信号</a>
            </div>
          </div>
        </dd>
      </dl>
      <a href="" class="fixed-bar">复制微信号</a>
    </div>

  </div>
</template>

<script>
export default {
  name: 'HeadTeacher'
}
</script>

<style scoped lang="stylus">
  #headteacher
    .title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
    .main
      padding: 0 .4rem
      background-color: #fff
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      dl
        display: flex
        justify-content: space-between
        align-items: flex-start
        margin-top: .32rem
        dt
          position: relative
          z-index: 100
          display: block
          width: .56rem
          height: .56rem
          line-height: .56rem
          background-color: #1E81F2
          font-size: .32rem
          color: #fff
          font-weight: 500
          text-align: center
          -webkit-border-radius: 50%
          -moz-border-radius: 50%
          border-radius: 50%
        dd
          width: 6.04rem
          height: 3.76rem
          background-color: #fff
          padding: .4rem .48rem
          -webkit-border-radius: .1rem
          -moz-border-radius: .1rem
          border-radius: .1rem
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          -webkit-box-shadow: 0 0 1.5rem .3rem #F7F7F7
          -moz-box-shadow: 0 0 1.5rem .3rem #F7F7F7
          box-shadow: 0 0 1.5rem .3rem #F7F7F7
          h3
            font-size: .32rem
            color: #0C0C0C
            font-weight: 600
          p
            margin-top: .16rem
            font-size: .24rem
            color: #A3A9B7
        &.yuyue
          dt
            &::before
              content: ""
              position: absolute
              top: .18rem
              left: .15rem
              display: block
              width: .2rem
              height: .1rem
              border-left: .03rem solid #fff
              border-bottom: .03rem solid #fff
              -webkit-transform: rotate(-45deg)
              -moz-transform: rotate(-45deg)
              -ms-transform: rotate(-45deg)
              -o-transform: rotate(-45deg)
              transform: rotate(-45deg)
            &::after
              content: ""
              position: absolute
              top: .56rem
              left: .26rem
              display: block
              width: .04rem
              height: 1.66rem
              border-left: .04rem dashed #1E81F2
          dd
            height: 1.92rem
            padding-top: .2rem
        &.step2
          dd
            .profile
              display: flex
              justify-content: space-between
              align-items: flex-start
              margin-top: .32rem
              .left
                width: 1.28rem
                height: 1.28rem
                overflow: hidden
                -webkit-border-radius: 50%
                -moz-border-radius: 50%
                border-radius: 50%
                img
                  width: 100%
                  height: 100%
              .right
                width: 3.28rem
              p
                line-height: .4rem
                margin-top: 0
                font-size: .24rem
                color: #A3A9B7
              a
                display: block
                width: 1.8rem
                height: .58rem
                line-height: .58rem
                background-color: #FF7052
                margin-top: .28rem
                font-size: .24rem
                color: #fff
                text-align: center
                -webkit-border-radius: .29rem
                -moz-border-radius: .29rem
                border-radius: .29rem
    a.fixed-bar
      position: fixed
      bottom: .32rem
      left: 50%
      display: block
      width: 4.38rem
      height: .8rem
      line-height: .8rem
      background-color: #FF7052
      font-size: .24rem
      color: #fff
      text-align: center
      -webkit-border-radius: .4rem
      -moz-border-radius: .4rem
      border-radius: .4rem
      -webkit-transform: translate(-50%, 0)
      -moz-transform: translate(-50%, 0)
      -ms-transform: translate(-50%, 0)
      -o-transform: translate(-50%, 0)
      transform: translate(-50%, 0)
</style>



// WEBPACK FOOTER //
// src/components/personal/HeadTeacher.vue